import { z } from 'zod'

export const teamSearchSchema = z.object({
  tab: z.enum(['members', 'teams', 'contacts']).optional(),
  page: z.coerce.number().int().min(0).optional(),
  size: z.coerce.number().int().positive().optional(),
  search: z.string().optional(),
  sortBy: z.string().optional(),
  teamId: z.string().optional(),
  teamName: z.string().optional()
})
